import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { Currency, LoanStatusExternal, MetricAgentView } from '@nemuru-eng/js-api-client';

import { LoanStatusExternalScoreCard } from '@/components/modules/Metrics/MetricAggregateViews/components/LoanStatusExternalScoreCard';
import { TimeInterval } from '@/components/modules/Metrics/shared/entities/TimeInterval';
import { ScoreCardMetricKey } from '@/components/modules/Metrics/shared/types/ScoreCardMetricKey';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { PendingDataType } from '@/config/types';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

interface MerchantChannelAgentMetricViewsProps {
  currency: Currency;
  timeInterval: TimeInterval;
  loanStatusExternal: LoanStatusExternal[];
  hasRequested: boolean;
  filteredMetrics?: MetricAgentView[];
  selectedMetricsType?: ScoreCardMetricKey;
  setSelectedLoanStatusExternal?: React.Dispatch<React.SetStateAction<LoanStatusExternal>>;
}

export const MerchantChannelAgentMetricViews = ({
  currency,
  timeInterval,
  loanStatusExternal,
  hasRequested,
  filteredMetrics,
  selectedMetricsType,
  setSelectedLoanStatusExternal,
}: MerchantChannelAgentMetricViewsProps) => {
  const { md } = useScreen();
  const { customBorderRadius } = useCustomTheme();

  if (!filteredMetrics) return <PendingDataWarning type={PendingDataType.NO_METRICS_INFORMATION} />;

  return (
    <Box pt={1} pb={4}>
      <Box
        display={'flex'}
        flexDirection={md ? 'row' : 'column'}
        width={'100%'}
        maxWidth={md ? '100%' : '560px'}
        flexWrap={'wrap'}
        gridGap={'20px'}
      >
        {hasRequested === false &&
          loanStatusExternal.map((i) => (
            <Skeleton
              key={`skeleton-mav-${i}`}
              variant="rect"
              height={md ? 148 : 66.4}
              style={{ borderRadius: customBorderRadius.paper, minWidth: md ? '200px' : '100%' }}
            />
          ))}
        {hasRequested === true &&
          loanStatusExternal.map((status, i) => (
            <Box
              key={`scorecard-mav-${i}`}
              onClick={setSelectedLoanStatusExternal ? () => setSelectedLoanStatusExternal(status) : undefined}
              style={{ cursor: setSelectedLoanStatusExternal ? 'pointer' : 'default' }}
              minWidth={md ? '200px' : '100%'}
            >
              <LoanStatusExternalScoreCard
                currency={currency}
                timeInterval={timeInterval}
                loanStatusExternal={status}
                selectedMetricsType={selectedMetricsType}
                filteredMetrics={filteredMetrics}
              />
            </Box>
          ))}
      </Box>
    </Box>
  );
};
